import React from "react";
import "./ContactsHeadercopy.css";

const ContactsHeadercopy = () => {
  return (
    <section className="ContactsHeader-container">
      <div className="ContactsHeader-overlay">
        <div className="container">
          <h1 className="ContactsHeader-title">About Us</h1>
          <div className="ContactsHeader-breadcrumb">
            <button className="btn btn-primary">
              Home <span className="ContactsHeader-icon">▢</span> About Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactsHeadercopy;
